import React from 'react';
import { features, type Feature } from '../data/site';
import { SterileIcon, PolishBottleIcon, CandleIcon } from './icons/NailIcons';
const iconFor: Record<Feature['icon'], React.ComponentType<{
  className?: string;
}>> = {
  sterile: SterileIcon,
  bottle: PolishBottleIcon,
  candle: CandleIcon
};
export function WhyChoose() {
  return <section className="w-full bg-blush-50 py-20 sm:py-28" data-id="element-309" data-mp="29rm6djk465wq">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-310" data-mp="2xgf33i8k8hse">
        <div className="max-w-2xl" data-id="element-311" data-mp="2xeu9pvxzf4w4">
          <p className="text-sm font-semibold text-rosegold-dark" data-id="element-312" data-mp="32g02ftrn6s5n">Por qué Cami Nails</p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-313" data-mp="2ogi86yvkumow">
            Tres cosas que nunca negocio
          </h2>
        </div>

        <ul className="mt-12 grid gap-8 md:grid-cols-3 md:gap-10" data-id="element-314" data-mp="2tgwkit47oisq">
          {features.map(feature => {
          const Icon = iconFor[feature.icon];
          return <li key={feature.id} className="flex h-full flex-col border-t border-blush-300 pt-7" data-id="element-315" data-mp="1i17x60n1phre">
                <Icon className="h-9 w-9 text-fucsia-deep" data-id="element-316" data-mp="28exhtovrueri" />
                <h3 className="mt-5 font-serif text-2xl font-semibold text-ink" data-id="element-317" data-mp="23gdrzde24itv">{feature.title}</h3>
                <p className="mt-3 text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-318" data-mp="2id4uhvj12anp">
                  {feature.description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}